import { TableLoader } from '@client/new/components/TableShared/TableLoader';
import { AsyncRenderer } from '../../components/AsyncRenderer/AsyncRenderer';
import { useBundlesVM } from './viewModel/bundles.viewModel';
import { BundlesView } from './view/BundlesView';
import { PageWrapper } from './view/PageWrapper';
import { useCustomizations } from '@client/new/hooks/use-customizations';
import { OtpMigrationWelcomeModal } from './view/OtpMigrationWelcomeModal';

export const BundlesManagementPage = (p: {
  params: { influencerId: string };
}) => {
  const creatorId = parseInt(p.params.influencerId) || 0;
  const vm = useBundlesVM({ creatorId });
  const { customizations } = useCustomizations(p.params.influencerId);
  const isOtpMigratedToBundle = customizations?.isOtpMigratedToBundle === true;

  return (
    <PageWrapper>
      <OtpMigrationWelcomeModal visible={isOtpMigratedToBundle} />
      <AsyncRenderer
        data={vm}
        loadRender={<Loader />}
        renderer={(data) => <BundlesView {...data} />}
      />
    </PageWrapper>
  );
};

const Loader = () => (
  <div className="mt-[90px]">
    <TableLoader rows={5} height={130} />
  </div>
);
